/** State of an attempted Registration activation */
export enum ACTIVATION_STATE {
    ACCOUNT_ALREADY_ACTIVATED = 'ACCOUNT_ALREADY_ACTIVATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    CODE_INVALID = 'CODE_INVALID',
    SUCCESS = 'SUCCESS',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    NONE = ''
}
